import * as React from 'react';
import { Alert, Box, Button, ButtonProps, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, Stack, TextField, Typography } from '@mui/material';
import $ from "jquery";
import { DataGrid, GridCsvExportOptions, GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector, useGridApiContext } from '@mui/x-data-grid';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import Common from '../../utilities/common';
import Layout from '../../components/Utilities/Layout';
import PestControlOutlinedIcon from '@mui/icons-material/PestControlOutlined';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined';
import ReactInterval from 'react-interval';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const ExportButton = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
        <Button
            {...buttonBaseProps}
            onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'comunidades_autonomas' })}
        >
            Exportar CSV
        </Button>
    );
}

export interface ILogViewState {
    data: any[];
    openDelete: boolean;
}

export default class LogView extends React.Component<{}, ILogViewState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            openDelete: false
        };
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Layout breadcrumb={
                [
                    {
                        title: 'Inicio',
                        url: '/'
                    },
                    {
                        title: 'Configuración',
                        url: '/settings'
                    },
                    {
                        title: 'Registro de eventos',
                        url: ''
                    }
                ]
            }>
                <ReactInterval timeout={3000} enabled={true} callback={() => {
                    this.Get();
                }}/>
                <Box className='stepper'>
                    <Grid container>
                        <Grid item xs={1}>
                            <Typography>
                                <PestControlOutlinedIcon className='mainIcon'/>
                            </Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography className='mainTitle'>
                            Registro de eventos
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                <Box className='main'>
                    <DataGrid
                        autoHeight
                        slots={{ toolbar: this.CustomToolbar.bind(this) }}
                        loading={this.state.data.length == 0}
                        slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                        rows={this.state.data}
                        hideFooter={this.state.data.length <= 30}
                        columns={[
                            { field: 'type', headerName: 'Tipo', width: 50, renderCell: ({ row }) => (
                                this.RenderIconStatus(row)
                            ) },
                            { field: 'date', headerName: 'Fecha', width: 150, renderCell: ({ row }) => (
                                `${new Date(row['date']).toLocaleDateString()} ${new Date(row['date']).toLocaleTimeString()}`
                            ) },
                            { field: 'userName', headerName: 'Usuario', width: 200 },
                            { field: 'entity', headerName: 'Entidad', width: 200 },
                            { field: 'method', headerName: 'Método', width: 200 },
                            { field: 'message', headerName: 'Mensaje', flex: 1 }
                        ]}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 30 },
                            },
                        }}
                        pageSizeOptions={[30, 60, 100]}
                    />
                </Box>
                <Dialog open={this.state.openDelete} fullWidth>
                    <DialogTitle>
                        Reestablecer registro
                    </DialogTitle>
                    <DialogContent>
                        ¿Desea reestablecer totalmente el registro de eventos?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.ResetLog.bind(this)}>OK</Button>
                        <Button onClick={() => {
                            this.setState(
                                {
                                    openDelete: false
                                }
                            )
                        }}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
            </Layout>
        )
    }

    private ResetLog(): void {
        let url = `${Common.END_POINT}/log/reset`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    openDelete: false
                }
            )
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            console.log(jqXHR);
        });
    }

    private Get(): void {
        let url = `${Common.END_POINT}/log`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    data: response
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            console.log(jqXHR);
        });
    }

    private RenderIconStatus(row: any) {
        switch(row['type'].toLowerCase()) {
            case 'error':
                return (
                    <ErrorOutlinedIcon color='error' titleAccess={'Error'} style={{position: 'relative', top: '5px'}}/>
                );
            case 'warning':
                return (
                    <WarningOutlinedIcon color='warning' titleAccess={'Error'} style={{position: 'relative', top: '5px'}}/>
                );
        }
    }

    private CustomToolbar() {
        return (
            <Stack direction={'row'} alignItems={'center'} className='toolbar' gap={'20px'}>
                <Button startIcon={<DeleteOutlineOutlinedIcon />} onClick={() => {
                    this.setState(
                        {
                            openDelete: true
                        }
                    );
                }}>
                    Reestablecer registro
                </Button>
                {
                    ExportButton()
                }
            </Stack>
        )

    }
}